export default __webpack_public_path__ + "static/media/placeholder_business05-es-web.b24b3b65.png";